/* Cubold blog: author line at the end of the article, collapsed table of contents */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function slug(text, used) {
    var base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
    var id = base, n = 2;
    while (used[id] || document.getElementById(id)) { id = base + '-' + n; n += 1; }
    used[id] = true;
    return id;
  }

  ready(function () {
    var content = document.querySelector('.article-template__content');
    if (!content) return;

    /* Author line sits right after the last paragraph */
    var byline = document.querySelector('[data-cg-byline]');
    if (byline) content.insertAdjacentElement('afterend', byline);

    /* Table of contents, closed until the reader opens it */
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < 4) return;

    var used = {};
    var details = document.createElement('details');
    details.className = 'cg-toc';
    var summary = document.createElement('summary');
    summary.className = 'cg-toc__summary';
    var label = document.createElement('span');
    label.textContent = 'In this article';
    var count = document.createElement('span');
    count.className = 'cg-toc__count';
    count.textContent = headings.length + ' sections';
    summary.appendChild(label);
    summary.appendChild(count);

    var list = document.createElement('ol');
    list.className = 'cg-toc__list';
    headings.forEach(function (h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      if (!h.id) h.id = slug(text, used);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);
    });

    details.appendChild(summary);
    details.appendChild(list);
    content.insertBefore(details, content.firstChild);
  });
})();